import axios from "axios";
import { servicePath } from 'constants/defaultValues';
import { getAccessToken } from 'helpers/Firebase';
import { getCurrentUser } from 'helpers/Utils';
import moment from 'moment';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
    CONTACTS_FETCH_ITEM,
    CONTACTS_ADD_ITEM,
    CONTACTS_DELETE_ITEM
} from './actions_def';
import {
    getContactItemSuccess,
    getContactItemError,
    addContactItemSuccess,
    addContactItemError,
    deleteContactItemSuccess,
    deleteContactItemError


} from './actions';


const apiUrl = servicePath;


const getContactItemRequest = async () => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success) => {
        const instance = axios.create({
            method: 'get',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });
        instance.get('/contacts/', { crossdomain: true })
            .then(response => success(response.data ?
                response.data.map(item => (
                    {
                        id: item.rfc_id,
                        title: item.rfc_title,
                        date: moment(item.date_created).format("Do MMM YYYY"),
                        change_date: moment(item.date_modified).format("Do MMM YYYY (hh:mm)"),
                        end_date: moment(item.rfc_implementation_end_date).format("Do MMM YYYY (hh:mm)"),
                        status: item.rfc_status,
                        statusColor: 'primary'
                    }
                )
                )
                :
                []));
    })
        .then((response) => response)
        .catch((error) => error);
};

function* getContactItem() {
    try {
        const response = yield call(getContactItemRequest);
        yield put(getContactItemSuccess(response));
    } catch (error) {
        yield put(getContactItemError(error));
    }
}


const addContactItemRequest = async (item) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success, fail) => {

        // success(notificationListData.data);
        var _user = getCurrentUser(); // JSON.parse(localStorage.getItem("user"));
        const instance = axios.create({
            method: 'post',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });

        // console.log('Sending :', {
        //   rfc_title: item.title,
        //   rfc_type: item.type ? item.type : 1,
        //   rfc_summary: item.detail ? item.detail : ' ',
        // })
        let _status = 1;
        switch (item.status) {
            case "PENDING": _status = 1; break;
            default: _status = 1;
        };

        let _sendingPayload = {
            rfc_title: item.title,
            rfc_type: item.type ? item.type : 1,
            rfc_summary: item.detail ? item.detail : ' ',
            rfc_implementation_start_date: item.start_date ? item.start_date : new Date(),
            rfc_status: _status,
            rfc_lead: _user.uid
        };

        // console.log(_sendingPayload, getAccessToken());
        instance.post('/contacts/',
            _sendingPayload,
            { crossdomain: true })
            .then(response => {
                if (response.data) {
                    if (response.data.status === "fail") {
                        fail(response.data);
                    }
                    else if (response.data.status === "success") {
                        success(response.data);
                    }
                    else {
                        console.log('Inconsistent behaviour', response.data.status)
                    }
                }
            }).catch((error) => {
                console.log(error)
            });;
    })
        .then((response) => response)
        .catch((error) => error);
};

function* addContactItem({ payload }) {

    try {
        const response = yield call(addContactItemRequest, payload);
        console.log('Response :', response, response.status === "fail")
        if (response.status !== "fail") {
            yield put(addContactItemSuccess(response));
        }
        else {
            yield put(addContactItemError(response));
        }
    } catch (error) {
        yield put(addContactItemError(error));
    }
}


const deleteContactRequest = async (item) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success, fail) => {
        console.log(item)
        const instance = axios.create({
            method: 'delete',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });

        instance.delete('/request_for_change/' + item + '/',
            { crossdomain: true })
            .then(response => {
                if (response.data) {
                    if (response.data.status === "fail") {
                        fail(response.data);
                    }
                    else if (response.data.status === "success" || response.data.status === "ok") {
                        success(response.data);
                    }
                    else {
                        console.log('Inconsistent behaviour', response.data.status);
                    }
                }
            }).catch((error) => {
                console.log(error);
            });
    })
        .then((response) => response)
        .catch((error) => error);
};

function* deleteContactItem({ payload }) {
    // console.log(payload);
    try {
        const response = yield call(deleteContactRequest, payload);
        console.log('Response :', response, response.status === "fail")
        if (response.status !== "fail") {
            yield put(deleteContactItemSuccess(response));
        }
        else {
            yield put(deleteContactItemError(response));
        }
    } catch (error) {
        yield put(addContactItemError(error));
    }
}


export function* watchFetchItem() {
    yield takeEvery(CONTACTS_FETCH_ITEM, getContactItem);
}

export function* watchAddItem() {
    yield takeEvery(CONTACTS_ADD_ITEM, addContactItem);
}
export function* watchDeleteItem() {
    yield takeEvery(CONTACTS_DELETE_ITEM, deleteContactItem);
}


export default function* rootSaga() {
    yield all([
        fork(watchAddItem),
        fork(watchFetchItem),
        fork(watchDeleteItem),
    ]);
}
